import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SafeHTML, SafeUrl } from '@common/pipes';
import { RoutePaths } from '@helper/route-paths';
import { StaticPageRepositoryService } from '@service/static-page-repository.service';
import { GetStaticPageRequest } from '@proto/store/api/store/static_page';
import { Constants } from '@helper/constants';
import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';

interface IDialogData {
  url: string;
}

@Component({
  selector: 'app-iframe-dialog',
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SafeUrl, NgIf, SafeHTML, ImageLoadingComponent, MatDialogModule, FocusRemoverDirective],
})
export class IframeDialogComponent implements OnInit {
  readonly data: IDialogData = inject(MAT_DIALOG_DATA);
  readonly pageContent = signal('');
  readonly iframeUrl = signal('');

  private readonly pattern = new RegExp(`^${Constants.LINK_URL_HOST.replace(/\./g, '\\.')}/${RoutePaths.PAGE}/(.+)`);
  private readonly lativRepository = inject(StaticPageRepositoryService);
  private readonly destroyRef = inject(DestroyRef);

  static open(dialog: MatDialog, url: string): MatDialogRef<IframeDialogComponent, undefined> {
    const data: IDialogData = { url };
    return dialog.open(IframeDialogComponent, {
      width: '550px',
      height: '550px',
      data,
    });
  }

  ngOnInit(): void {
    const id = this.data.url.match(this.pattern)?.[1];
    if (id) {
      this.lativRepository
        .getStaticPage(GetStaticPageRequest.fromPartial({ id }))
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: res => this.pageContent.set(res.source),
          error: () => this.iframeUrl.set(this.data.url),
        });
    } else {
      this.iframeUrl.set(this.data.url);
    }
  }
}
